let fancyFileElements = document.querySelectorAll('.fancyFile .fancyElement');
fancyFileElements?.forEach((el) => {
    el.addEventListener('change', () => {
        let filename = el.value.split("\\").pop();
        el.parentElement.querySelector('.inputPlaceholder').innerHTML = filename;
        el.parentElement.classList.add('clicked');
    });
    if (el.parentElement.querySelector('.fancyFileName')?.innerHTML) {
        el.parentElement.querySelector('.inputPlaceholder').innerHTML = el.parentElement.querySelector('.fancyFileName')?.innerHTML;
        el.parentElement.classList.add('clicked');
    }
});